<script setup lang="ts">
    import { CardTitle } from '@/components/ui/card';
    import { columns } from '@/tables/columns/roles';
    import { Head } from '@inertiajs/vue3';
    import { usePermissions } from '@/composables/usePermissions';
    import { useQuery } from '@tanstack/vue-query';
    import AppLayout from '@/layouts/AppLayout.vue';
    import axios from 'axios';
    import CreateRoles from '@/components/roles/CreateRoles.vue';
    import DataTable from '@/components/datatable/DataTable.vue';
    import DataTableToolbarActions from '@/components/datatable/DataTableToolbarActions.vue';
    import PageCard from '@/components/PageCard.vue';
    import Permission from '@/enums/Permission';
    import QueryKey from '@/enums/QueryKey';
    import type { BreadcrumbItem } from '@/types';

    const { hasPermission } = usePermissions();

    const breadcrumbs: BreadcrumbItem[] = [
        {
            title: 'menu.settings',
        },
        {
            title: 'menu.roles',
            href: route('v2.roles.index'),
        },
    ];

    const { isPending, isFetching, isError, data, error, refetch } = useQuery({
        queryKey: [QueryKey.ROLES],
        queryFn: getRoles,
    });

    async function getRoles() {
        const { data } = await axios.get(route('v2.roles.table'));
        return data.data;
    }
</script>

<template>
    <Head :title="$t('roles.page_header')" />

    <AppLayout :breadcrumbs="breadcrumbs">
        <PageCard>
            <DataTable
                :table-key="QueryKey.ROLES"
                :columns="columns"
                :data="data"
                :loading="isPending"
                :default-column-visibility="{
                    id: false,
                }"
            >
                <template #title>
                    <CardTitle>
                        {{ $t('roles.page_header') }}
                    </CardTitle>
                </template>
                <template #actions>
                    <DataTableToolbarActions name="roles">
                        <CreateRoles v-if="hasPermission(Permission.ROLES_CREATE)" />
                    </DataTableToolbarActions>
                </template>
            </DataTable>
        </PageCard>
    </AppLayout>
</template>
